import { render } from "./index.vue?vue&type=template&id=19772cd2"
import script from "./signup.ts?vue&type=script&lang=js"
export * from "./signup.ts?vue&type=script&lang=js"

import "./signup.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script